import { equationParts, equationPolynomial, polynomialNumber, unwrapEquationNode as unwrap, closeEquationNumber as close } from "./equationPolynomial";

function isConstant(node) {
  try { polynomialNumber(equationPolynomial(node)); return true; } catch { return false; }
}

function terms(raw) {
  const node = unwrap(raw);
  if (node.isOperatorNode && ["+", "-"].includes(node.op)) return node.args.flatMap(terms);
  return [node];
}

function canonicalTerm(raw) {
  const node = unwrap(raw);
  if (node.isOperatorNode && ["+", "-"].includes(node.op) && node.args.length === 1) return canonicalTerm(node.args[0]);
  if (node.isOperatorNode && node.op === "*") {
    if (isConstant(node.args[0])) return canonicalTerm(node.args[1]);
    if (isConstant(node.args[1])) return canonicalTerm(node.args[0]);
    return false;
  }
  if (node.isOperatorNode && node.op === "/" && isConstant(node.args[1])) return canonicalTerm(node.args[0]);
  if (!node.isOperatorNode || node.op !== "^" || polynomialNumber(equationPolynomial(node.args[1])) !== 2) return false;
  const base = equationPolynomial(node.args[0]);
  return close(base.get("1,0") || 0, 1) && [...base].every(([key, value]) => value === 0 || ["0,0", "1,0"].includes(key));
}

function generalTerm(raw) {
  const node = unwrap(raw);
  if (isConstant(node)) return true;
  if (node.isSymbolNode) return node.name === "x";
  if (!node.isOperatorNode) return false;
  if (["+", "-"].includes(node.op) && node.args.length === 1) return generalTerm(node.args[0]);
  if (node.op === "*") return node.args.every(generalTerm);
  if (node.op === "/") return isConstant(node.args[1]) && generalTerm(node.args[0]);
  return node.op === "^" && unwrap(node.args[0]).isSymbolNode && unwrap(node.args[0]).name === "x"
    && [1, 2].includes(polynomialNumber(equationPolynomial(node.args[1])));
}

export function checkQuadraticExpression(input, expected, { form }) {
  try {
    if (typeof input !== "string") return false;
    const rhs = input.replace(/^\s*(?:f\s*\(\s*x\s*\)|y)\s*=/i, "");
    const [, node] = equationParts(`y=${rhs}`);
    const poly = equationPolynomial(node);
    if ([...poly].some(([key, value]) => value !== 0 && !["0,0", "1,0", "2,0"].includes(key))) return false;
    const variableTerms = terms(node).filter(term => !isConstant(term));
    if (form === "canonical" && (variableTerms.length !== 1 || !canonicalTerm(variableTerms[0]))) return false;
    if (form === "general" && !terms(node).every(generalTerm)) return false;
    return [ ["2,0", expected.a], ["1,0", expected.b], ["0,0", expected.c] ]
      .every(([key, value]) => Number.isFinite(value) && close(poly.get(key) || 0, value));
  } catch { return false; }
}
